/* eslint-disable import/no-cycle */
import axios from 'axios'
import store from '../utils/store'
import {
  API_ACCEPT_DELIVERY,
  API_CANCEL_ORDER,
  API_CREATE_OPTION,
  API_CREATE_OPTION_ITEM,
  API_CREATE_PRODUCT,
  API_CREATE_SECTION,
  API_DELETE_OPTION,
  API_DELETE_PRODUCT,
  API_GENERATE_ACCESS_TOKEN_HUBRISE,
  API_GET_BILLING_SHOP,
  API_GET_COMPLETED_ORDERS,
  API_GET_CUSTOMER_ORDERS,
  API_GET_GEOCODE_FROM_ADDRESS,
  API_GET_PLACE_AUTOCOMPLETE,
  API_GET_PLACE_DETAIL,
  API_GET_SALES_SHOP,
  API_LUNCH_DELIVERY,
  API_NOTIFICATION,
  API_PREPARE_ORDER,
  API_READY_TO_TAKEAWAY,
  API_REFUND_PAYMENT,
  API_SYNCHRONIZE_MENU_HUBRISE,
  API_UPDATE_NOTIFICATION,
  API_UPDATE_OPTION,
  API_UPDATE_OPTION_ITEM,
  API_UPDATE_PRODUCT,
  API_UPDATE_SECTION,
  API_UPLOAD_IMAGE,
  API_VALIDATE_ORDER,
  API_UPDATE_AUTOACCEPT,
  API_UPDATE_EXPIRED_PROMOTION,
  API_UPDATE_SHOP_SETTINGS,
  API_UPDATE_USER_SERVICE_PRICE,
  API_UPDATE_DRIVER_SERVICE_PRICE,
  API_DELETE_USER_SERVICE_PRICE,
  API_UPDATE_SHOP_PAYMENT_AND_SALES_TYPE,
  API_DELETE_OPEN_CITIES,
  API_UPDATE_CITY_NAME,
  API_DELETE_DELIVERY_ZONE,
  API_UPDATE_DELIVERY_ZONE_NAME,
  API_UPDATE_SUB_LOCALITIES,
  API_UPDATE_DISTRICTS,
  API_UPDATE_SPECIAL_HOUR,
  API_UPDATE_SHOP_LAUNCH,
  API_UPDATE_SHOP_HOURS,
  API_UPDATE_SHOP_PRINTER,
  API_DELETE_SPECIAL_HOUR,
  API_GET_CONFIGURATION,
  API_GET_ALL_MENUS,
  API_DELETE_DISTRICTS,
  API_DELETE_SUB_LOCALITIES,
  API_UPDATE_MENU_POSITION,
  API_UPDATE_PRODUCT_STOCK, API_UPDATE_SECTION_ACTIVATION, API_UPDATE_SECTIONS,
  API_GET_FIRST_BILLING, API_GET_LAST_BILLING, API_GET_CANCELED_ORDER, API_DELETE_SECTION, API_DELETE_SUPPORT,
  API_CREATE_PRINT_ORDER, API_GET_ONE_SHOP, API_UPDATE_CONFIGURATION_ACTIVATION, API_UPDATE_DELIVERY_USER_SERVICE_PRICE,
  API_UPDATE_DELIVERY_DRIVER_SERVICE_PRICE, API_UPDATE_WEBAPP_KEYWORDS, API_UPDATE_WEBAPP_CART_PHRASE, API_UPDATE_DESIGN_WEB,
  API_UPDATE_DESIGN_WEB_MOBILE, API_UPDATE_DESIGN_MOBILE, API_UPDATE_NEW_PRODUCTS, API_UPDATE_CONFIGURATION_PAYMENT_AND_SALES_TYPE, API_GET_ALL_USERS,
  API_UPDATE_ORDER_SETTINGS, API_DELETE_CONFIGURATION_USER_SERVICE_PRICE, API_UPDATE_DRIVERS_PAYMENT_VALUES, API_GET_SHOP_USERS, API_GET_CONFIGURATION_SERVICE_PRICE, API_GET_COMPANY_SHOP_IDS,
  API_GET_ROLES_AND_PERMISSIONS
} from '../constants'
import { getFirebaseCustomerId, getIdToken } from './firebase'
import { removeEmptyStringFromObjectValues } from '../utils/tools'
import moment from 'moment'
import { sendCloudWatchAlert } from '../utils/applicationError'
import { decrypt } from '../utils/encryption'

export const initializeBackend = domain => {
  //domain = 'https://thomas.dishop.ngrok.dev'
  axios.defaults.baseURL = String(domain);
  return true;
};

export const sendGetRequest = async (url, data, headers, addCompanyIdToBody = true) => {
  try {
    const { companyId } = store.getState().user;
    const newData = addCompanyIdToBody
      ? { ...data, companyId }
      : data;
    const response = await axios({
      method: 'get',
      url,
      params: newData,
      headers
    });
    return response;
  } catch (error) {
    const errorMessage = error.response ? error.response.data.errorMessage : error;
    throw errorMessage;
  }
};

export const sendDeleteRequest = async (url, data, headers) => {
  try {
    const { companyId } = store.getState().user;
    const newData = { ...data, companyId };
    const response = await axios({
      method: 'delete',
      url,
      data: newData,
      headers
    });
    return response;
  } catch (error) {
    const errorMessage = error.response ? error.response.data.errorMessage : error;
    throw errorMessage;
  }
};

export const sendPostRequest = async (url, data, headers, compId, addCompanyIdToBody = true) => {
  let companyId = '';
  try {
    if (addCompanyIdToBody) {
      if (!compId) {
        companyId = store.getState().user.companyId;
      } else {
        companyId = compId;
      }
    }
    const newData = addCompanyIdToBody
      ? { ...data, companyId }
      : data;
    if (addCompanyIdToBody && compId === '') {
      delete newData.companyId
    }
    return axios({
      method: 'post',
      url,
      data: newData,
      headers
    });
  } catch (error) {
    throw error.response ? `${error.response.data.errorMessage}` : error;
  }
};

export const sendPutRequest = async (url, data, headers, compId, addCompanyIdToBody = true) => {
  let companyId = '';
  try {
    if (!compId) {
      companyId = store.getState().user.companyId;
    } else {
      companyId = compId;
    }
    const newData = addCompanyIdToBody ? { ...data, companyId } : data;
    if (addCompanyIdToBody && compId === '') {
      delete newData.companyId
    }
    const response = await axios({
      method: 'put',
      url,
      data: newData,
      headers
    });
    return response;
  } catch (error) {
    const errorMessage = error.response ? `${error.response.data.errorMessage}` : error;
    throw errorMessage;
  }
};
export const generateHubriseAccess = async authorizationCode => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_GENERATE_ACCESS_TOKEN_HUBRISE,
    { shopId, authorizationCode },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const createProduct = async (product, sectionKey, shopIds = []) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;
  delete product.hidden // FIX when hidden = true disabled fields are forced to true in backend which leads to undesired behavior
  await sendPostRequest(
    API_CREATE_PRODUCT(companyId, shopId, sectionKey),
    { product, shopIds },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const updateProduct = async (product, sectionKey, productKey, shopIds = []) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;
  delete product.hidden // FIX when hidden = true disabled fields are forced to true in backend which leads to undesired behavior
  await sendPutRequest(
    API_UPDATE_PRODUCT(companyId, shopId, sectionKey, productKey),
    { product, shopIds },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const deleteProduct = async (key, sectionKey, synchronize, shops) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  const { data } = await sendPostRequest(
    API_DELETE_PRODUCT,
    { shopId, sectionKey, key, keepSection: true, synchronize, shops },
    { Authorization: `Bearer ${idToken}` }
  );
  return data;
};
export const updateSection = async (section, sectionKey, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  delete section['iconCompressedUrl'];
  await sendPutRequest(
    API_UPDATE_SECTION(companyId, shopId, sectionKey),
    {
      section,
      shopIds
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const createSection = async (section, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  await sendPostRequest(
    API_CREATE_SECTION(companyId, shopId),
    {
      section,
      shopIds
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const synchronizeMenuHubrise = async () => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_SYNCHRONIZE_MENU_HUBRISE,
    { shopId, replace: true },
    { Authorization: `Bearer ${idToken}` }
  );
};
export const createOptionCategory = async (optionCategory, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const option = removeEmptyStringFromObjectValues({ ...optionCategory });
  await sendPostRequest(
    API_CREATE_OPTION(companyId, shopId),
    {
      option,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};
export const updateOptionCategory = async (optionCategory, optionKey, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const option = removeEmptyStringFromObjectValues({ ...optionCategory });
  await sendPutRequest(
    API_UPDATE_OPTION(companyId, shopId, optionKey),
    {
      option,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const createOptionCategoryItem = async (optionKey, newItem, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const item = removeEmptyStringFromObjectValues({ ...newItem });
  await sendPostRequest(
    API_CREATE_OPTION_ITEM(companyId, shopId, optionKey),
    {
      item,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const updateOptionCategoryItem = async (optionKey, updatedItem, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const item = removeEmptyStringFromObjectValues({ ...updatedItem });
  await sendPutRequest(
    API_UPDATE_OPTION_ITEM(companyId, shopId, optionKey, updatedItem.key),
    {
      item,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const deleteOptionCategory = async (categoryKey, synchronize, shops, optionKey) => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_DELETE_OPTION,
    {
      shopId,
      key: categoryKey,
      optionKey,
      synchronize,
      keepCategory: true,
      shops
    },
    { Authorization: `Bearer ${idToken}` }
  );
};
export const uploadImage = async image64 => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  const { data = '' } = await sendPostRequest(
    API_UPLOAD_IMAGE,
    {
      shopId,
      image64
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return data;
};

export const mooveOrderToCook = async (order, preparationTime) => {
  const idToken = await getIdToken();
  await sendPostRequest(
    API_PREPARE_ORDER,
    {
      customerId: order.id,
      preparationTime,
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const mooveOrderToTakeAway = async order => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_READY_TO_TAKEAWAY(companyId, order?.chargeId, order?.id),
    {

    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};

export const mooveOrderToCancel = async (order, cancelReason) => {
  const idToken = await getIdToken();
  const cancellation = {
    canceledBy: 'shop',
    cancelReason,
    chargeId: order.chargeId
  };
  await sendPostRequest(
    API_CANCEL_ORDER,
    {
      customerId: order.id,
      cancellation,
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const refundOrder = async (order, isPastOrder) => {
  const { shopId, id: customerId, chargeId } = order;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_REFUND_PAYMENT,
    {
      shopId,
      customerId,
      chargeId,
      isPastOrder
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const mooveOrderToPastOrder = async order => {
  const idToken = await getIdToken();
  await sendPostRequest(
    API_VALIDATE_ORDER,
    {
      customerId: order.id,
      validatedBy: 'shop',
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const getCustomerOrders = async customerId => {
  const idToken = await getIdToken();
  const response = await sendGetRequest(
    API_GET_CUSTOMER_ORDERS,
    {
      customerId
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};

export const getSales = async (shopId, startAt, endAt) => {
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    API_GET_SALES_SHOP,
    {
      shopId,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};

export const getBilling = async (shopId, startAt, endAt) => {
  const idToken = await getIdToken()
  const response = await sendPostRequest(
    API_GET_BILLING_SHOP,
    {
      shopId,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};

export const getCompletedOrders = async (shopId, orderBy, equalTo, startAt, endAt) => {
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    API_GET_COMPLETED_ORDERS,
    {
      shopId,
      orderBy,
      equalTo,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};
export const menuSynchronisation = async (resetMenu, resetPrice, updatePaymentTypes) => {
  const { shopId, companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/shops/${shopId}/menu/synchronization`,
    {
      updatePaymentTypes,
      resetMenu,
      resetPrice
    },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const getAllDrivers = async (isFreelance) => {
  const { shopId, companyId } = store.getState().user;
  if (shopId && getFirebaseCustomerId()) {
    const idToken = await getIdToken();
    const response = await sendGetRequest(
      `/api/${companyId}/shops/${shopId}/drivers`,
      {
        isFreelance
      },
      { Authorization: `Bearer ${idToken}` }
    );
    return response.data;
  }

};
export const updateManagementFee = async (managementFee) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(

    `/api/${companyId}/configuration/management-fees`,

    managementFee
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};

export const getLoyaltyPrograms = async () => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendGetRequest(
    `/api/${companyId}/loyalty-programs`,
    {},
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;
};
export const updateLoyaltyConfiguration = async (configuration) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/configuration/loyalty`,

    configuration
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const addLoyaltyVersion = async (versionName, minBasket, defaultVersion) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions`,

    { versionName, minBasket, defaultVersion }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const updateLoyaltyVersion = async (versionName, minBasket, defaultVersion, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPutRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/configuration`,

    { versionName, minBasket, defaultVersion }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const deleteLoyaltyVersion = async (key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendDeleteRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}`,
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const addVersionShops = async (shopIds, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/shops`,

    { shopIds }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const addOfferedProducts = async (program, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  return sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/products`,
    program,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId,
    false
  );

};
export const getDeepLinks = async () => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendGetRequest(
    `/api/${companyId}/deeplinks`,
    {},
    { Authorization: `Bearer ${idToken}` }
  );
  return response.data;

};
export const addNewDeepLink = async (campaign, channel) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  return sendPostRequest(
    `/api/${companyId}/deeplinks`,
    { campaign, channel },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId,
    false
  );

};

export const getDeepLinksAnalytics = async (campaign, channel, startDate, endDate, creationDate) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();

  const todayMinus2Days = moment().subtract(2, 'days');

  endDate = moment(endDate).isAfter(todayMinus2Days) ? todayMinus2Days : moment(endDate);

  if (!creationDate || !creationDate && endDate.isAfter(todayMinus2Days)) {
    startDate = moment(startDate).subtract(2, 'days');
  }

  const params = new URLSearchParams({
    campaign,
    channel,
    startDate: moment(startDate).format('YYYY-MM-DD'),
    endDate: moment(endDate).format('YYYY-MM-DD'),
    isRealTime: false
  }).toString();

  try {
    const response = await sendGetRequest(
      `/api/${companyId}/deeplinks/analytics?${params}`,
      null,
      {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      false
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des données d'analyse:", error);
    throw error;
  }
};

export const lunchDelivery = async (order) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_LUNCH_DELIVERY(companyId, order?.chargeId, order?.id),
    {},
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};
export const acceptDelivery = async (order) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  await sendPostRequest(
    API_ACCEPT_DELIVERY(companyId, order?.chargeId, order?.id),
    {},
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};
export const pushNotification = async ({ title, message, scheduledDate, toAllUsers }) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPostRequest(
      API_NOTIFICATION(companyId),
      {
        toAllUsers,
        shopId: toAllUsers ? null : shopId,
        title,
        message,
        scheduledDate
      },
      { Authorization: `Bearer ${idToken}` }
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in pushNotification: ${err}`);
  }
}
export const updatePushNotification = async ({ title, message, scheduledDate, toAllUsers, id }) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(
      API_UPDATE_NOTIFICATION(companyId, id),
      {
        toAllUsers,
        shopId: toAllUsers ? null : shopId,
        title,
        message,
        scheduledDate
      },
      { Authorization: `Bearer ${idToken}` }
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in pushNotification: ${err}`);
  }
}
export const deleteNotification = async (pushNotificationId, isAllUsers) => {
  const { companyId, shopId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendDeleteRequest(
    `/api/${companyId}/push-notifications/${pushNotificationId}`,
    { shopId: isAllUsers ? null : shopId },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};

export const getPlacesAutocomplete = async (placeInput) => {
  try {
    const { companyId } = store.getState().user;
    const idToken = await getIdToken();
    const headers = { Authorization: `Bearer ${idToken}` };
    const data = { placeInput };
    const result = await sendGetRequest(
      API_GET_PLACE_AUTOCOMPLETE(companyId),
      data,
      headers,
      false
    );
    return result.data;
  } catch (error) {
    sendCloudWatchAlert(`Could not get places autocomplete for address ${placeInput}: ${error}`);
    throw error
  }
}

export const getPlacesDetails = async (placeId) => {
  try {
    const { companyId } = store.getState().user;
    const idToken = await getIdToken();
    const headers = { Authorization: `Bearer ${idToken}` };
    const result = await sendGetRequest(
      API_GET_PLACE_DETAIL(companyId, placeId),
      {},
      headers,
      false
    );
    return result.data;
  } catch (error) {
    sendCloudWatchAlert(`Could not get places details for placeId ${placeId}: ${error}`);
    throw error
  }
}

export const getGeocodeByAddress = async (address) => {
  try {
    const idToken = await getIdToken();
    const data = { address };
    const headers = { Authorization: `Bearer ${idToken}` };
    const { companyId } = store.getState().user;
    const response = await sendGetRequest(API_GET_GEOCODE_FROM_ADDRESS(companyId), data, headers, false)
    return response.data.results
  } catch (error) {
    sendCloudWatchAlert(`Could not get geocode for address : ${address} ${error}`)
    throw error
  }
}
export const updateShopConfigurationAutoAccept = async (enabled, preparationTime) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(
      API_UPDATE_AUTOACCEPT(companyId, shopId),
      {
        enabled, preparationTime
      },
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop configuration autoAccept: ${err}`);
  }
}
export const updateExpiredPromotion = async (shopId, promotionKey, expired) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(
      API_UPDATE_EXPIRED_PROMOTION(companyId, shopId, promotionKey),
      {
        expired
      },
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in activation promo code: ${err}`);
  }
}
export const updateSupportConfiguration = async (charges, support, cancelFee) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(
      API_UPDATE_SHOP_SETTINGS(companyId, shopId),
      {
        charges, support, cancelFee
      },
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop support configuration: ${err}`);
  }
}
export const updateDeliveryServicePrice = async (isClient, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const apiPath = isClient ? API_UPDATE_USER_SERVICE_PRICE : API_UPDATE_DRIVER_SERVICE_PRICE
  try {
    await sendPutRequest(
      apiPath(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation delivery fee: ${err}`);
  }
}
export const deleteShopDeliveryUserServicePrice = async () => {
  const { companyId, shopId } = store.getState().user;
  const idToken = await getIdToken();
  const response = await sendDeleteRequest(API_DELETE_USER_SERVICE_PRICE(companyId, shopId),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
};
export const updateShopMethodType = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_SHOP_PAYMENT_AND_SALES_TYPE(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop configuration method type: ${err}`);
  }
};
export const deleteShopOpenCities = async (cityName) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const response = await sendDeleteRequest(API_DELETE_OPEN_CITIES(companyId, shopId, cityName),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
}
export const deleteShopDistrict = async (cityName, districtName) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const response = await sendDeleteRequest(API_DELETE_DISTRICTS(companyId, shopId, cityName, districtName),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
}
export const deleteShopSubLocalities = async (cityName, subLocalityName) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const response = await sendDeleteRequest(API_DELETE_SUB_LOCALITIES(companyId, shopId, cityName, subLocalityName),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
}

export const updateShopOpenCitiesCityName = async (cityName, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_CITY_NAME(companyId, shopId, cityName),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop city name: ${err}`);
  }
}
export const updateShopDeliveryZoneName = async (key, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_DELIVERY_ZONE_NAME(companyId, shopId, key),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop delivery zone name: ${err}`);
  }
}
export const deleteShopDeliveryZone = async (key) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const response = await sendDeleteRequest(API_DELETE_DELIVERY_ZONE(companyId, shopId, key),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
}
export const updateShopSubLocalitiesAndDistricts = async (isSubLocality, cityName, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const apiPath = isSubLocality ? API_UPDATE_SUB_LOCALITIES : API_UPDATE_DISTRICTS
  try {
    await sendPutRequest(apiPath(companyId, shopId, cityName),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop ${isSubLocality ? 'subLocalities' : 'districts'}: ${err}`);
  }
}
export const updateShopSpecialHour = async (specialHourKey, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_SPECIAL_HOUR(companyId, shopId, specialHourKey),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop special hour: ${err}`);
  }
}
export const updateShopInformation = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_SHOP_LAUNCH(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop information: ${err}`);
  }
}
export const updateShopHours = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_SHOP_HOURS(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop hours: ${err}`);
  }
}
export const updateShopPrinter = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_SHOP_PRINTER(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation shop hours: ${err}`);
  }
}
export const deleteShopSpecialHour = async (specialHourKey) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const response = await sendDeleteRequest(API_DELETE_SPECIAL_HOUR(companyId, shopId, specialHourKey),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
}
export const getCompanyConfiguration = async (companyId, idToken) => {
  const baseUrl = determineBaseUrl()
  const apiUrl = new URL(API_GET_CONFIGURATION(companyId), baseUrl).toString();
  const response = await sendGetRequest(apiUrl,
    null,
    { Authorization: `Bearer ${idToken}` },
    false
  );
  return response.data;
};
export const getALLMenus = async () => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const response = await sendGetRequest(API_GET_ALL_MENUS(companyId),
    null,
    { Authorization: `Bearer ${idToken}` },
    false
  );
  return response.data;
};
export const updateMenuPosition = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_MENU_POSITION(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation menu position: ${err}`);
  }
}
export const updateProductStock = async (sectionKey, productKey, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_PRODUCT_STOCK(companyId, shopId, sectionKey, productKey),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation product stock: ${err}`);
  }
}
export const updateSectionActivation = async (sectionKey, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_SECTION_ACTIVATION(companyId, shopId, sectionKey),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation section activation: ${err}`);
  }
}
export const updateSections = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_SECTIONS(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error from ${shopId} in updation sections: ${err}`);
  }
}

export const getInvoiceBilling = async (isFirst) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    const apiPath = isFirst ? API_GET_FIRST_BILLING : API_GET_LAST_BILLING;
    const response = await sendGetRequest(apiPath(companyId),
      null,
      { Authorization: `Bearer ${idToken}` },
      false
    );
    return response.data;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in getting invoice billing : ${err}`);
  }
};
export const getCanceledOrder = async (userId, orderId) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    const response = await sendGetRequest(API_GET_CANCELED_ORDER(companyId, userId, orderId),
      null,
      { Authorization: `Bearer ${idToken}` },
      false
    );
    return response.data;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in getting canceledOrder : ${err}`);
  }
};
export const deleteMenuSection = async (shopId, sectionKey) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    const response = await sendDeleteRequest(API_DELETE_SECTION(companyId, shopId, sectionKey),
      null,
      {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`
      },
      ''
    );
    return response;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in deleting menu section : ${err}`);
  }
}
export const deleteSupport = async (userId, orderId) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    const response = await sendDeleteRequest(API_DELETE_SUPPORT(companyId, userId, orderId),
      null,
      {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`
      },
      ''
    );
    return response;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in deleting support : ${err}`);
  }
}
export const printOrdersCreate = async (userId, orderId, data) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;
  await sendPostRequest(
    API_CREATE_PRINT_ORDER(companyId, shopId, userId, orderId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};
export const getOneShop = async (companyId, shopId, idToken) => {
  try {
    const response = await sendGetRequest(API_GET_ONE_SHOP(companyId, shopId),
      null,
      { Authorization: `Bearer ${idToken}` },
      false
    );
    return response.data;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in getting one shop : ${err}`);
  }
};
export const updateConfigurationActivation = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_CONFIGURATION_ACTIVATION(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation activation : ${err}`);
  }
}
export const updateDeliveryServiceFee = async (isClient, data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const apiPath = isClient ? API_UPDATE_DELIVERY_USER_SERVICE_PRICE : API_UPDATE_DELIVERY_DRIVER_SERVICE_PRICE
  try {
    await sendPutRequest(apiPath(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation delivery ${isClient ? 'user' : 'driver'} service fee : ${err}`);
  }
}
export const updateWebappKeywords = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_WEBAPP_KEYWORDS(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation webapp keywords : ${err}`);
  }
}
export const updateWebappCartPhrase = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_WEBAPP_CART_PHRASE(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation webapp cart phrase : ${err}`);
  }
}
export const updateDesignWeb = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_DESIGN_WEB(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation design web : ${err}`);
  }
}
export const updateDesignWebMobile = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_DESIGN_WEB_MOBILE(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation design web mobile : ${err}`);
  }
}
export const updateDesignMobile = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_DESIGN_MOBILE(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation design mobile : ${err}`);
  }
}
export const updateNewProducts = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_NEW_PRODUCTS(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation new products : ${err}`);
  }
}
export const updateConfigurationMethodType = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_CONFIGURATION_PAYMENT_AND_SALES_TYPE(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation configuration method type : ${err}`);
  }
}
export const getAllUsers = async (page, filter, withFilter) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const data = withFilter ? { filters: filter } : {
    pagination: {
      batchNumber: 1,
      batchSize: page?.rowsPerPage * (page?.numPage + 1)
    }
  }
  try {
    const response = await sendGetRequest(API_GET_ALL_USERS(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      false
    );
    return response.data;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in fetching all users : ${err}`);
  }
};
export const getShopUsers = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    const response = await sendGetRequest(API_GET_SHOP_USERS(companyId, shopId),
      data,
      { Authorization: `Bearer ${idToken}` },
      false
    );
    return response.data;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in fetching shop users : ${err}`);
  }
};
export const updateConfigurationOrderSettings = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_ORDER_SETTINGS(companyId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation configuration order settings : ${err}`);
  }
}
export const deleteConfigurationUserServicePrice = async () => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const response = await sendDeleteRequest(API_DELETE_CONFIGURATION_USER_SERVICE_PRICE(companyId),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
}
export const updateDriversPaymentValues = async (driverId, data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    await sendPutRequest(API_UPDATE_DRIVERS_PAYMENT_VALUES(companyId, driverId),
      data,
      { Authorization: `Bearer ${idToken}` },
      companyId,
      false
    );
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in updation drivers payment type : ${err}`);
  }
}
export const generateCsvFileForOneShop = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    const response = await axios.get(API_GET_SHOP_USERS(companyId, shopId), {
      params: data,
      headers: { Authorization: `Bearer ${idToken}` },
      responseType: 'blob',
    });
    return response.data;
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in generating csv file for one shop: ${err}`);
  }

}
export const generateCsvFileForALLShops = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  try {
    const response = await axios.get(API_GET_ALL_USERS(companyId), {
      params: data,
      headers: { Authorization: `Bearer ${idToken}` },
      responseType: 'blob',
    });
    return response.data;
  } catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Error  in generating csv file for all shops: ${err}`);
  }
}
export const getCompanyFirebaseCredentials = async (companyId) => {
  try {
    const baseUrl = determineBaseUrl()
    const encryptedFirebaseCredentials = await axios({
      method: 'get',
      url: `${baseUrl}/api/firebase/credentials`,
      params: { companyId }
    });
    const decryptedFirebaseCredentials = await decrypt(encryptedFirebaseCredentials?.data)
    return decryptedFirebaseCredentials ? JSON.parse(decryptedFirebaseCredentials) : null
  } catch (error) {
    sendCloudWatchAlert(`Could not fetch firebase credentials of company ${companyId} : ${error}`);
    throw error
  }
}
const determineBaseUrl = () => {
  const windowUrl = window.location.origin
  if (windowUrl?.includes('dev-dashboard') || !windowUrl || windowUrl?.includes('localhost')) {
    return `https://dev-backend.dishop.co`
  }
  return `https://api.dishop.co`
}
export const getConfigurationServicePrice = async (companyId, idToken) => {
  try {
    const response = await sendGetRequest(API_GET_CONFIGURATION_SERVICE_PRICE(companyId),
      null,
      { Authorization: `Bearer ${idToken}` },
      false
    );
    return response.data;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Could not fetch configuration service price : ${err}`);
  }
};
export const getCompanyIds = async (companyId, idToken) => {
  const baseUrl = determineBaseUrl()
  try {
    const apiUrl = new URL(API_GET_COMPANY_SHOP_IDS(companyId), baseUrl).toString()
    const response = await sendGetRequest(apiUrl,
      null,
      { Authorization: `Bearer ${idToken}` },
      false
    );
    return response.data;
  }
  catch (err) {
    console.error(err)
    sendCloudWatchAlert(`Could not fetch company ids: ${err}`);
  }
};
export const getRolesAndPermissions = async (companyId, userId, idToken) => {
  try {
    const baseUrl = determineBaseUrl();
    const apiUrl = new URL(API_GET_ROLES_AND_PERMISSIONS(companyId, userId), baseUrl).toString()
    const response = await sendGetRequest(apiUrl,
      { companyId },
      { Authorization: `Bearer ${idToken}` },
      false
    );
    const decryptedUserRoles = await decrypt(response.data)
    return decryptedUserRoles ? JSON.parse(decryptedUserRoles) : null
  } catch (error) {
    sendCloudWatchAlert(`Could not fetch roles and permissions ${companyId} : ${error}`);
    throw error
  }
}